import $http from '@Config/axios';

const prefix = 'rastreabilidade';

export const TraceabilityPresenter = {
	updateTraceability: (boxId, data) => $http.put(`${prefix}`, {
		boxId,
		items: data
	})
};
